import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { CustomCmsVideoComponent } from '../../../models/cms-links.model'

@Component({
    selector: 'app-homepage-paragraph-section6',
    templateUrl: './homepage-paragraph-section6.component.html',
    styleUrl: './homepage-paragraph-section6.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HomepageParagraphSection6Component implements OnInit {
  public componentData: CustomCmsVideoComponent;

  constructor(public component: CmsComponentData<CustomCmsVideoComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
